import(/* webpackMode: "eager" */ "/runner/_work/mx-platform/mx-platform/cdn/de-sxm-www/src/app/[...slug]/error.tsx");
